import React from 'react';
import useCreateComplexField from 'Global/Hooks/useCreateComplexField';
import { LinearProgress } from '@mui/material';
import { EditGroupViewContextProvider } from './context/EditGroupViewContextProvider';
import EditGroupViewInnerContent from './EditGroupViewInnerContent';

const EditGroupedView = ({
  StateBank,
  fieldArrayName,
  DefaultValues,
  fetchedFrom,
  liftState,
  surveyDisable,
}) => {
  const {
    fields,
    control,
    formState,
    getValues,
    reset,
    watch,
    setValue,
  } = useCreateComplexField(
    `${fieldArrayName}`,
    DefaultValues
  );
  // const [, setEditFormValue] = useAtom(EditWatchAtom);
  // React.useEffect(() => {
  //   const subscription = watch(() => setEditFormValue(watch()));
  //   return () => subscription.unsubscribe();
  // }, [watch]);


  console.log('StateBank?.title-->',StateBank)

  return (
    <EditGroupViewContextProvider watch={watch}>
      <React.Fragment>
        {StateBank?.title?.length > 0 ? (
          <EditGroupViewInnerContent
            StateBank={StateBank}
            control={control}
            errors={formState?.errors}
            fields={fields}
            getValues={getValues}
            reset={reset}
            fieldArrayName={fieldArrayName}
            fetchedFrom={fetchedFrom}
            setValue={setValue}
            liftState={liftState}
            surveyDisable={surveyDisable}
          />
        ) : (
          <LinearProgress />
        )}
      </React.Fragment>
    </EditGroupViewContextProvider>
  );
};

export default EditGroupedView;
